import { CIQError, ErrorResponse, IRestClientErrorRequest } from "./models/api";

export class SimpleRestServiceError extends Error {
  request: IRestClientErrorRequest;
  response: ErrorResponse<CIQError>;

  constructor(
    request: IRestClientErrorRequest,
    response: ErrorResponse<CIQError>
  ) {
    super(response.message || "API error");
    this.name = "SimpleRestServiceError";
    this.request = request;
    this.response = response;
  }

  toJSON() {
    return {
      response: this.response,
      request: this.request
    };
  }
}
